import { call, put, delay } from 'redux-saga/effects';
import { BACKEND_URL, LOADING_DELAY } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import processError from '../../../utils/processError';
import {
  authorizedCheckSuccess,
  authorizedLoginFailed,
  authorizedLogoutSuccessful,
} from '../actions';

export default function* authorizedCheck(action) {
  try {
    const url = `${BACKEND_URL}/auth/me`;
    const pool = {};
    yield delay(LOADING_DELAY);
    const userDataResponse = yield makeRequest(url, pool, action, 'GET');
    const authorizedData = yield userDataResponse.json();
    if (userDataResponse.status === OK && authorizedData) {
      yield put(authorizedCheckSuccess(authorizedData));
      yield call(resolveActionPromise(action, authorizedData));
    } else {
      yield put(authorizedLoginFailed(authorizedData));
      yield call(rejectActionPromise(action, authorizedData));
    }
  } catch (e) {
    yield put(authorizedLogoutSuccessful(e));
    yield processError(e);
  }
}
